import { render, staticRenderFns } from "./MyViolation.vue?vue&type=template&id=af66ac6c&scoped=true"
import script from "./MyViolation.vue?vue&type=script&lang=js"
export * from "./MyViolation.vue?vue&type=script&lang=js"
import style0 from "./MyViolation.vue?vue&type=style&index=0&id=af66ac6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af66ac6c",
  null
  
)

export default component.exports